<template>
  <div>
    <div class="bg" style="padding-bottom: 20px">
      <FxedTop ref="fxedTop"></FxedTop>
    </div>
    <div class="page">
      <div class="pageTitle">
        <div class="sort"></div>
        <div class="currentLocation">
          <div class="currentLocation">
            当前位置：首页 > 继续教育 > 课程详情
          </div>
        </div>
      </div>
      <!-- 课程详情 -->
      <div class="main" v-loading="loading">
        <div class="left">
          <img :src="curriculum.logo" class="userCurriculumLogo" />
        </div>
        <div class="right">
          <div class="text_20">{{ curriculum.className }}</div>
          <div class="content">
            <div class="item">
              <div class="name">学时</div>
              <div class="dec">{{ curriculum.learnHour }}</div>
            </div>
            <div class="item">
              <div class="name">讲师</div>
              <div class="dec">{{ curriculum.lecturer || "-" }}</div>
            </div>
          </div>

          <div class="mianfei">
            <span v-if="curriculum.tuitionFee > 0" style="color: red">￥</span>
            <span v-if="curriculum.tuitionFee > 0" style="color: red">{{
              curriculum.tuitionFee
            }}</span>
          </div>

          <div v-if="curriculum.isJoin">
            <span class="btn" @click="gochapter(null)">开始学习</span>
          </div>
          <div v-else>
            <span class="btn" @click="addClass">加入课程</span>
          </div>
        </div>
      </div>
      <!-- tab切换 -->
      <div class="homePage" style="margin-bottom: 20px">
        <div class="homePageContent">
          <div class="tabList">
            <div
              v-for="(item, index) in tabList"
              :key="index"
              :class="currindex == index ? 'activeTabItem' : 'tabItem'"
              @click="currindex = index">
              {{ item }}
            </div>
          </div>

          <div class="lineHeight"></div>
          <!-- 课程介绍 -->
          <div class="courseIntroduction" v-if="currindex == 0">
            {{ curriculum.introduction }}
          </div>
          <!-- 课程列表 -->
          <div class="courseList" v-if="currindex == 1">
            <div v-if="catalogueList.length > 0">
              <div
                class="list"
                v-for="(item, index) in catalogueList"
                :key="index">
                <div class="item" @click="gochapter(item)">
                  <div class="leftCon">
                    <div class="itemCon">
                      <div class="itemDesc">{{ item.name }}</div>
                      <div
                        v-if="item.isComplete == 0 && item.type != 5"
                        class="itemDetail"
                        style="color: #999">
                        未开始
                      </div>
                      <div
                        v-if="item.isComplete == 1 && item.type != 5"
                        class="itemDetail"
                        style="color: #999">
                        已完成学习
                      </div>
                      <div
                        v-if="item.isComplete == 2 && item.type != 5"
                        class="itemDetail">
                        已观看{{ parseInt(item.videoTime) / 60 }}分钟
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              style="text-align: center; color: #999; line-height: 100px">
              暂无数据
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />

    <FaceMatch
      ref="faceMatch"
      :classId="catalogueList[0].classId"
      :classSectionId="catalogueList[0].classSectionId"
      :schoolClassId="curriculum.schoolClassId"
      @success="faceMatchSuccess"></FaceMatch>
  </div>
</template>

<script>
import FxedTop from "@/components/FxedTop";
import Footer from "@/components/Footer.vue";
import FaceMatch from "@/components/faceMatch.vue";
import { joinClassGroup, getClassGroupDetail } from "@/api/wkApi";
export default {
  components: {
    FxedTop,
    Footer,
    FaceMatch,
  },
  data() {
    return {
      // tabList: ["课程介绍", "课程列表", "课程评价", "积分排行"],
      tabList: ["课程介绍", "课程列表"],
      loading: true,
      currindex: 0,
      tipText: "暂无课程",
      grouplist: [],
      // 评论
      commentValue: "",
      classId: "",
      schedule: [],
      catalogueList: [],
      commentsList: [],
      cartNum: 0,
      curriculum: {
        totalVideoTime: 0,
      },
      classInfo: {},
      discussion: "",
      meInfo: {},
      rankingList: [],
      pageNumRank: 1,
      // 课程总时长
      totalDuration: 0,
    };
  },
  created() {
    this.getSchoolClassDetail(); // 班级详情
  },
  methods: {
    faceMatchSuccess() {
      const obj = this.catalogueList[0];
      this.$router.push({
        path: "/course/video",
        query: {
          classId: obj.classId,
          sectionId: obj.classSectionId,
          classGroupId: obj.classGroupId,
          schoolClassId: this.curriculum.schoolClassId,
        },
      });
    },
    // 获取班级详情
    getSchoolClassDetail() {
      getClassGroupDetail(this.$route.query.classGroupId).then((res) => {
        this.loading = false;
        if (res.result) {
          if (res.result.logo) {
            res.result.logo = res.result.logo.replace(
              "https://xzzhuanji.cn/ework/",
              "https://zwyun.xzzhuanji.cn:18443/zhuanji/"
            );
            res.result.logo = res.result.logo.replace("/202508", "");
          }
          if (res.result.logoBase64) {
            res.result.logo = `data:image/jpeg;base64,${res.result.logoBase64}`;
          }
          this.curriculum = res.result;
          this.curriculum.totalVideoTime = 0;
          // 计算总时长
          if (this.curriculum.classList.length > 0) {
            this.curriculum.classList[0].classSectionList.forEach((item) => {
              this.curriculum.totalVideoTime =
                this.curriculum.totalVideoTime + item.videoTime;
            });
            this.catalogueList = this.curriculum.classList[0].classSectionList;
          }
        } else {
          this.$message.error("获取数据失败");
        }
      });
    },
    // 小节跳转
    gochapter(obj) {
      if (!obj) {
        obj = this.catalogueList[0];
      }
      if (this.curriculum.isJoin != 1) {
        return this.$message.warning("请先加入课程才能开始学习");
      }
      if (this.curriculum.speedRate >= 100) {
        this.$router.push({
          path: "/course/video",
          query: {
            classId: obj.classId,
            sectionId: obj.classSectionId,
            classGroupId: obj.classGroupId,
            schoolClassId: this.curriculum.schoolClassId,
          },
        });
      } else {
        this.$refs.faceMatch.uploadFaceImg();
      }
    },
    // 加入课程
    async addClass(item) {
      this.loading = true;
      const res = await joinClassGroup({
        classGroupId: this.$route.query.classGroupId,
      });
      if (res.code == 200) {
        this.$message.success(res.result);
        this.getSchoolClassDetail();
      } else {
        this.$message.warning("请先登录系统!");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
  .left {
    margin-right: 40px;
    .userCurriculumLogo {
      width: 288px;
      height: 288px;
      border-radius: 10px;
    }
  }
  .right {
    .text_20 {
      width: 100%;
      color: rgba(68, 68, 68, 1);
      font-size: 24px;
      margin-left: 2px;
    }
    .content {
      display: flex;
      .item {
        padding: 30px 0;
        text-align: center;
        margin-right: 60px;
        .name {
          overflow-wrap: break-word;
          color: rgba(118, 118, 118, 1);
          font-size: 17px;
          text-align: left;
          line-height: 30px;
          text-align: center;
        }
        .dec {
          overflow-wrap: break-word;
          color: rgba(248, 85, 89, 1);
          font-size: 16px;
          text-align: left;
          line-height: 30px;
          text-align: center;
        }
      }
    }
    .mianfei {
      font-weight: normal;
      font-size: 18px;
      color: #7ed321;
      margin-bottom: 30px;
    }
    .btn {
      padding: 5px 30px;
      border-radius: 5px;
      font-weight: normal;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: right;
      font-style: normal;
      background: linear-gradient(180deg, #ffc000 0%, #f76b1c 100%);
      cursor: pointer;
    }
  }
}

.homePage {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 40px;
  box-sizing: border-box;
  background: #fff;
  .homePageContent {
    .tabList {
      display: flex;
      font-size: 22px;
      .tabItem {
        cursor: pointer;
        font-weight: 400;
        color: #333;
        margin-right: 40px;
        line-height: 35px;
      }
      .activeTabItem {
        margin-right: 40px;
        line-height: 35px;
        cursor: pointer;
        font-weight: 400;
        color: red;
        border-bottom: 2px solid red;
      }
    }

    .lineHeight {
      width: 100%;
      height: 1px;
      background: #dcdcdc;
      margin: 20px 0;
    }

    // 课程介绍
    .courseIntroduction {
      font-size: 18px;
      font-weight: 400;
      color: #333;
      line-height: 30px;
      min-height: 300px;
      // 首行缩进2个字符
      text-indent: 2em;
    }

    // 课程列表
    .courseList {
      font-size: 18px;
      min-height: 300px;
      .list {
        padding: 20px 0;
        border-bottom: 1px solid #dcdcdc;
        .item {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          .leftCon {
            .itemCon {
              flex: 1;
              .itemDesc {
                margin-bottom: 5px;
              }
              .itemDetail {
                font-weight: 400;
              }
            }
          }
        }
        .rightStudy {
          font-size: 16px;
          font-weight: 400;
          height: 40px;
          line-height: 40px;
          color: #fff;
          background: linear-gradient(180deg, #41a0f1 0%, #0a5b9f 100%);
          padding: 0 12px;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
